module.exports = __webpack_public_path__ + "img/light_bar.1f4bee07.png";